import React, { useState, useEffect, useCallback} from 'react';
import Layout from '../components/Layout';
import { Button } from '../components/ui/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../components/ui/table';
import { Badge } from '../components/ui/badge';
import { MapPin, Truck } from 'lucide-react';
import { toast } from 'react-hot-toast';

const RouteSchedulingPage = () => {
  const [routes, setRoutes] = useState([]);

  const backendUrl = process.env.REACT_APP_BACKEND_URL;


  const fetchRoutes = useCallback(async () => {
    try {
      const response = await fetch(`${backendUrl}/api/route-scheduling/routes`);
      const data = await response.json();
      setRoutes(data);
    } catch (error) {
      toast.error('Failed to load routes');
    }
  }, [backendUrl]);

  useEffect(() => {
    fetchRoutes();
  }, [fetchRoutes]);

  const getStatusBadge = (status) => {
    const colors = {
      'Planned': 'bg-orange-100 text-orange-800',
      'In Progress': 'bg-yellow-100 text-yellow-800',
      'Completed': 'bg-green-100 text-green-800',
      'Cancelled': 'bg-red-100 text-red-800'
    };
    return <Badge className={colors[status] || 'bg-gray-100 text-gray-800'}>{status}</Badge>;
  };

  return (
    <Layout>
      <div className="p-6">
        <div className="flex justify-between items-center mb-6">
          <div>
            <h1 className="text-2xl font-bold">Route Scheduling</h1>
            <p className="text-gray-600">Manage delivery routes and logistics</p>
          </div>
          <Button disabled>
            <MapPin className="w-4 h-4 mr-2" />
            Create Route
          </Button>
        </div>

        {/* Routes Table */}
        <div className="bg-white rounded-lg shadow overflow-hidden">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Route Number</TableHead>
                <TableHead>Route Date</TableHead>
                <TableHead>Vehicle ID</TableHead>
                <TableHead>Driver ID</TableHead>
                <TableHead className="text-right">Total Stops</TableHead>
                <TableHead className="text-right">Completed</TableHead>
                <TableHead>Status</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {routes.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={7} className="text-center py-8 text-gray-500">
                    <Truck className="w-12 h-12 mx-auto mb-2 text-gray-400" />
                    <div>No routes found</div>
                  </TableCell>
                </TableRow>
              ) : (
                routes.map((route) => (
                  <TableRow key={route.route_number}>
                    <TableCell className="font-medium">{route.route_number}</TableCell>
                    <TableCell>{route.route_date}</TableCell>
                    <TableCell>{route.vehicle_id || '-'}</TableCell>
                    <TableCell>{route.driver_id || '-'}</TableCell>
                    <TableCell className="text-right">{route.total_stops}</TableCell>
                    <TableCell className="text-right">{route.completed_stops}</TableCell>
                    <TableCell>{getStatusBadge(route.status)}</TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </div>
      </div>
    </Layout>
  );
};

export default RouteSchedulingPage;